import { useMediaQuery } from '@material-ui/core';
import LoginIcon from '@mui/icons-material/Login';
import { Box, Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';
import { Link } from 'react-router-dom';

import Logo from '../../Images/UCFmark-Small_horizontal_WGrgb_72ppi.png'

function PublicNavBar(props) {
    return (
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ background: '#262626', height: 55, px: 1, position: 'sticky', top: 0, zIndex: 1251 }}>
            <Stack direction='row' alignItems='flex-end' >
                <img
                    src={Logo}
                    alt='UCF Logo'
                    width='88px'
                />
            </Stack>
            <Stack direction='row' alignItems='center' spacing={3} justifyContent='center'>
                <Link to='/' className='navbar-link'>Overview</Link>
                <Link to='/projects' variant='h6' className='navbar-link'>Projects</Link>
            </Stack>
            <Box>
                <a href='https://www.cs.ucf.edu/~cssd' style={{textDecoration: 'none'}} >
                    <Button variant='outlined' style={{ color: '#FFC904', borderColor: '#FFC904' }}>Portal Login<LoginIcon /></Button>
                </a>
            </Box>
        </Stack>
    );
}

export default PublicNavBar;